export enum VideoDataTypesEnum {
    Other = 'other',
    YT = 'youtube',
    VM = 'vimeo'
}
